import { Avatar, Link, Typography } from '@mui/material';
import { CustomMetaTitle } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useAppSelector, useIsDesktop } from 'Hooks';
import { SuccessRequest } from 'Images';

interface IProps {
  tabValue: number;
}
export const SuccessHeaderContent = ({ tabValue }: IProps) => {
  const isDesktop = useIsDesktop();
  const dictionary = Dictionary[DICTIONARY.UniversalRequest];

  const otpData = useAppSelector(
    ({ otpLoginDetails: { otpLoginDetails } }) => otpLoginDetails
  );

  return (
    <>
      <CustomMetaTitle
        title={`${dictionary.title} - ${dictionary.successDialog.title}`}
        disablePrefix
      />
      {otpData && otpData.email && tabValue === 0 && (
        <Typography
          mb={isDesktop ? '28px' : '14px'}
          fontSize={isDesktop ? '28px' : '20px'}
          textAlign={'center'}
        >
          {dictionary.successDialog.headerTitle1}
        </Typography>
      )}
      <Typography
        mb={isDesktop ? '28px' : '24px'}
        textAlign={'center'}
        variant='h4'
        component='p'
      >
        {otpData
          ? dictionary.successDialog.headerTitle2
          : dictionary.successDialog.headerTitleOTP}
        <Link
          sx={{ textDecoration: 'underline' }}
          ml={1}
          href={dictionary.successDialog.headerTitleUrl}
        >
          {otpData
            ? dictionary.successDialog.headerTitleUrlLabel
            : dictionary.successDialog.headerTitleUrlLabelOTP}
        </Link>
      </Typography>
      <Avatar
        src={SuccessRequest}
        alt={''}
        sx={{
          width: '200px',
          height: '183px',
          mb: 8,
          alignSelf: 'center',
        }}
      />
    </>
  );
};
